import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 text-center text-[color:var(--azsam-ink-soft)]" data-testid="protected-loading">
        Checking your session…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
